<template>
  <div class="error-wrapper">
    <h1>:(</h1>
    <h2 class="error-title">{{titleValue}}</h2>
    <p class="error-message">{{messageValue}}</p>
  </div>
</template>

<script>
  export default {
    name: 'ErrorMessage',
    props: ['title', 'message'],
    computed: {
      titleValue() {
        return this.title ? this.title : 'En feil har oppstått'
      },
      messageValue() {
        return this.message ? this.message : 'Kunne ikke laste inn data'
      }
    }
  };
</script>

<style scoped>
  .error-wrapper {
    text-align: center;
  }

  .error-title {
    text-transform: uppercase;
  }

  .error-message {

  }
</style>
